import { CardContent } from '@mui/material';
import { Chart } from 'react-chartjs-2';
import { withTheme, DefaultTheme } from 'styled-components';
import 'chart.js/auto';
import { MinimalCard } from 'components/styled';
import { Typography, Spacer, ChartWrapper } from './styles';

const DataHistory = withTheme(
  ({ theme }: { theme: DefaultTheme; dataHistoryPerDataTypes?: unknown }) => {
    const data = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      datasets: [
        {
          label: 'Sales',
          backgroundColor: theme.palette.secondary.main,
          borderColor: theme.palette.secondary.main,
          hoverBackgroundColor: theme.palette.secondary.main,
          hoverBorderColor: theme.palette.secondary.main,
          data: [54, 67, 41, 55, 62, 45, 55, 73, 60, 76, 48, 79],
          barPercentage: 0.625,
          categoryPercentage: 0.5,
        },
        {
          label: 'Revenue',
          backgroundColor: theme.palette.grey[200],
          borderColor: theme.palette.grey[200],
          hoverBackgroundColor: theme.palette.grey[200],
          hoverBorderColor: theme.palette.grey[200],
          data: [69, 66, 24, 48, 52, 51, 44, 53, 62, 79, 51, 68],
          barPercentage: 0.625,
          categoryPercentage: 0.5,
        },
      ],
    };

    return (
      <MinimalCard $hoverEffect={false} sx={{ mb: 6 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Sales / Revenue
          </Typography>

          <Spacer mb={6} />

          <ChartWrapper>
            <Chart type="bar" data={data} />
          </ChartWrapper>
        </CardContent>
      </MinimalCard>
    );
  },
);

export default DataHistory;
